import { db } from '../components/Dexie';
import { log } from './loggingService';

const API_BASE_URL = 'https://deadapi.techysumo.it/backoffice';
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Sincronizza le chiamate Apache salvandole in Dexie.
 * @returns {Promise<{success: boolean, count: number, error?: string}>}
 */
export const syncDocalls = async () => {
  try {
    log("Avvio sincronizzazione _docalls...", 'INFO');

    const response = await fetch(`${API_BASE_URL}/getDoCalls`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': API_KEY,
      },
      body: JSON.stringify({ limit: 1000, offset: 0 }), // Scarichiamo un buon numero di record per l'uso locale
    });

    if (!response.ok) {
      throw new Error(`Errore API: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();

    if (result.result && Array.isArray(result.details)) {
      await db.docalls.bulkPut(result.details);
      log(`Sincronizzati ${result.details.length} record _docalls in Dexie.`, 'INFO');
      return { success: true, count: result.details.length };
    } else {
      return { success: false, count: 0, error: result.text || 'Risposta API non valida' };
    }
  } catch (error) {
    log("Errore durante la sincronizzazione di _docalls:", 'ERROR', error);
    return { success: false, count: 0, error: error.message };
  }
};

/**
 * Recupera le chiamate Apache dalla tabella _docalls (mantenuta per compatibilità).
 * @param {Object} params - Parametri per la ricerca.
 */
export const searchDocalls = async (params = {}) => {
  // In una vera implementazione offline-first, qui potremmo decidere se fare un fetch fresco
  // o semplicemente restituire i dati dal DB. Per ora, facciamo solo il sync.
  return await syncDocalls();
};
